function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42 26C42 28.209 40.209 30 38 30H4C1.791 30 0 28.209 0 26V4C0 1.791 1.791 0 4 0H38C40.209 0 42 1.791 42 4V26Z",
  fill: "#3F51B5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27 5C24.3478 5 21.8043 6.05357 19.9289 7.92893C18.0536 9.8043 17 12.3478 17 15C17 17.6522 18.0536 20.1957 19.9289 22.0711C21.8043 23.9464 24.3478 25 27 25C29.6522 25 32.1957 23.9464 34.0711 22.0711C35.9464 20.1957 37 17.6522 37 15C37 12.3478 35.9464 9.8043 34.0711 7.92893C32.1957 6.05357 29.6522 5 27 5Z",
  fill: "#FFC107"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M19.014 21C18.55 20.383 18.151 19.716 17.838 19H23.163C23.441 18.364 23.659 17.696 23.8 17H17.202C17.07 16.354 17 15.686 17 15H24C24 14.314 23.93 13.646 23.799 13H17.201C17.343 12.304 17.56 11.636 17.838 11H23.163C22.85 10.284 22.452 9.617 21.987 9H19.014C19.451 8.42 19.944 7.878 20.495 7.405C18.747 5.909 16.481 5 14 5C8.477 5 4 9.477 4 15C4 20.523 8.477 25 14 25C17.269 25 20.162 23.425 21.986 21H19.014Z",
  fill: "#FF3D00"
});

var SvgMastercard = function SvgMastercard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mastercard.ff58c45b.svg";
export { ForwardRef as ReactComponent };